import { BaseEventType, ChatEventType } from '../types/enums/ProviderEventType';
import { WithListener } from '../utils/WithListener';
import {
	ProviderCloseEvent,
	ProviderErrorEvent,
	ProviderMessageEvent,
	ProviderOpenEvent,
} from '../models/ProviderEvents';
import {
	ChatEchoEvent,
	ChatErrorEvent,
	ChatMessageEvent,
} from '../models/ChatEvents';

export interface IBaseChatProvider extends WithListener {
	clear(): void;
	onOpen(callback: (event: ProviderOpenEvent<Event>) => void): () => void;
	onClose(
		callback: (event: ProviderCloseEvent<CloseEvent>) => void,
	): () => void;
	onError(callback: (event: ProviderErrorEvent<Event>) => void): () => void;
	onMessageEvent(
		callback: (event: ProviderMessageEvent<MessageEvent>) => void,
	): () => void;
	onChatMessage(callback: (event: ChatMessageEvent) => void): () => void;
	onChatEcho(callback: (event: ChatEchoEvent) => void): () => void;
	onChatError(callback: (event: ChatErrorEvent) => void): () => void;
}
export class BaseChatProvider
	extends WithListener
	implements IBaseChatProvider
{
	clear() {
		this.listeners = {};
	}
	onOpen(callback: (event: ProviderOpenEvent<Event>) => void) {
		return this.on(BaseEventType.OPEN, callback);
	}
	onClose(callback: (event: ProviderCloseEvent<CloseEvent>) => void) {
		return this.on<ProviderCloseEvent>(BaseEventType.CLOSE, callback);
	}
	onError(callback: (event: ProviderErrorEvent<Event>) => void) {
		return this.on(BaseEventType.ERROR, callback);
	}
	onMessageEvent(
		callback: (event: ProviderMessageEvent<MessageEvent>) => void,
	) {
		return this.on(BaseEventType.MESSAGE, callback);
	}
	onChatMessage(callback: (event: ChatMessageEvent) => void) {
		return this.on(ChatEventType.CHAT_MESSAGE, callback);
	}
	onChatEcho(callback: (event: ChatEchoEvent) => void) {
		return this.on(ChatEventType.CHAT_ECHO, callback);
	}
	onChatError(callback: (event: ChatErrorEvent) => void) {
		return this.on(ChatEventType.CHAT_ERROR, callback);
	}
}
